import api from '../../../api/api'
// import { onOtpRequested } from '@utils/otpLock'
// import { AtLeastOnePropertyOf } from '@utils/types'
import * as UserTypes from './User.types'

// export const requestOTP = async (phoneNumber: string, purpose: UserTypes.PhoneNumberAuthPurpose) => {
//   await onOtpRequested()
//   const response = await api.post(`/auth/otp/request/${purpose}`, { phoneNumber })

//   return response
// }

/** CAUTION: It does not really return a full user object, it just has the _id in it */
export const phoneNumberLogin = (phoneNumber: string, code: string) =>
  api.post<UserTypes.AuthResponse>('/auth/otp', { phoneNumber, code })

/** CAUTION: It does not really return a full user object, it just has the _id in it */
export const phoneNumberCreateAccount = (data: UserTypes.PhoneNumberSignUpData) =>
  api.post<UserTypes.AuthResponse>('/auth/otp/signup', {
    phoneNumber: data.phoneNumber,
    code: data.code,
    profile: {
      firstName: data.profile.firstName,
      // birthYear: data.profile.birthYear,
      school: {
        name: ''
      }
      // country: data.profile.countryCode,
      // level: data.profile.level
    }
  })

/** CAUTION: It does not really return a full user object, it just has the _id in it */
export const signUpUser = (data: UserTypes.SignUpData) =>
  api.post<UserTypes.AuthResponse>('/auth/signup', {
    username: data.email,
    password: data.password,
    profile: {
      firstName: data.profile.firstName,
      // birthYear: data.profile.birthYear,
      school: {
        name: ''
      }
      // country: data.profile.countryCode,
      // level: data.profile.level
    }
  })

export const signInUser = (username: string, password: string) =>
  api.post<UserTypes.AuthResponse>('/auth', { username, password })

export const signUpUserViaSocial = (data: UserTypes.SignUpViaSocialData) =>
  api.post<UserTypes.SocialAuthResponse>('/auth/sso/signup', {
    idToken: data.firebaseIdToken,
    ssoProvider: data.ssoProvider,
    profile: {
      firstName: data.profile.firstName,
      // birthYear: data.profile.birthYear,
      school: {
        name: ''
      }
      // country: data.profile.countryCode,
      // level: data.profile.level
    }
  })

export const signInUserViaSocial = (firebaseIdToken: string) =>
  api.post<UserTypes.AuthResponse>('/auth/sso', { idToken: firebaseIdToken })

export const signUpCandidate = (data: UserTypes.CandidateSignUpData) =>
  api.post<UserTypes.AuthResponse>('/auth/candidate/signup', {
    profile: {
      firstName: data.firstName,
      birthYear: data.birthYear,
      school: {
        name: ''
      },
      country: data.countryCode
      // level: data.level
    }
  })

export const getUser = () => api.get<UserTypes.User>('/user')

export const getUpdateLists = () => api.get<UserTypes.UpdateLists>('/update-lists')

export const createProfile = (data: UserTypes.AsyncCreateProfileData) => api.post('/user/profile', data)

export const patchUserEmail = (email: string) => api.patch<UserTypes.AuthResponse>('/user/email', { email })

/**
 *  @deprecated Since phone number auth, this method should no longer be used to change email
 */
export const changeUserEmail = (email: string) =>
  api.patch<UserTypes.AuthResponse>('/user/username', { username: email })

export const changeUserPassword = (oldPassword: string, newPassword: string) =>
  api.patch<{ user: UserTypes.User; token: string }>('/user/password', {
    oldPassword,
    password: newPassword
  })

export const updateUserProfile = (profileData: UserTypes.ProfileUpdate | FormData) =>
  api.patch<UserTypes.User>('/user/profile', profileData)

export const sendRecoveryEmail = (email: string) => {
  return async () => {
    const { data } = await api.get(`/auth/reset-pass/${email}`)

    return data as UserTypes.ForgotPasswordResult
  }
}

export const resendVerificationEmail = async () => {
  try {
    await api.post('/auth/resend')
    return true
  } catch (error) {
    return false
  }
}

export const updateUser = (userData: Partial<UserTypes.User>) => api.patch<UserTypes.User>('/user', userData)

export const updateUserOnboardingCompleted = (onboardingCompleted: boolean) =>
  api.patch('/user', { onboardingCompleted })

export const updateUserScore = ({ score, scoreToAdd, bookId }: UserTypes.UpdateUserScoreData) =>
  api.patch<UserTypes.User>('/user/profile/points', {
    globalScore: score + scoreToAdd,
    ...(bookId ? { bookId } : {})
  })
